import { useEffect } from "react";
import { connect } from "react-redux";
import { fetchMatches } from "../actions/matches";

const MatchesAutoFetcher = ({ fetchMatches, autoRefreshInterval }) => {
  useEffect(() => {
    const interval = setInterval(() => {
      fetchMatches();
    }, autoRefreshInterval * 1000);

    return () => clearInterval(interval);
  }, [fetchMatches, autoRefreshInterval]);

  useEffect(() => {
    const handleFocus = () => {
      fetchMatches();
    };

    window.addEventListener("focus", handleFocus);

    return () => {
      window.removeEventListener("focus", handleFocus);
    };
  }, [fetchMatches]);

  return null;
};

const mapDispatchToProps = (dispatch) => ({
  fetchMatches: () => dispatch(fetchMatches()),
});

export default connect(null, mapDispatchToProps)(MatchesAutoFetcher);
